import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PAGE } from './routes';
import { initialisedGuard } from './core/guards/initialised.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/loading/loading.module').then((m) => m.LoadingPageModule),
  },
  {
    path: `${PAGE.GAME}/:gameId`,
    canActivate: [initialisedGuard],
    loadChildren: () => import('./features/game/game/game.module').then((m) => m.GamePageModule),
  },
  {
    path: PAGE.RESULTS,
    canActivate: [initialisedGuard],
    loadChildren: () =>
      import('./features/results/results.module').then((m) => m.ResultsPageModule),
  },
  {
    path: PAGE.CHOOSE_LEADERBOARDS,
    canActivate: [initialisedGuard],
    loadChildren: () =>
      import('./features/leaderboards/choose-leaderboards.module').then(
        (m) => m.ChooseLeaderboardsPageModule,
      ),
  },
  {
    path: `${PAGE.TOURNAMENT}/:tournamentId`,
    canActivate: [initialisedGuard],
    loadChildren: () =>
      import('./features/tournament/tournament.module').then((m) => m.TournamentPageModule),
  },
  {
    path: `${PAGE.SELECT_RULES}/:gameId`,
    canActivate: [initialisedGuard],
    loadChildren: () =>
      import('./features/rules/select-rules.module').then((m) => m.SelectRulesPageModule),
  },
  { path: '**', redirectTo: PAGE.RESULTS },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
